/**
 * Service de gestion des réservations
 * Centralise tous les appels API liés aux réservations et billets
 */
import apiService from './api.service';

class ReservationService {
  /**
   * Obtenir les réservations par vendeur/gare
   * Note: L'API utilise POST au lieu de GET pour cette récupération
   */
  async getReservationsBySeller(data) {
    console.log('🔧 Service - getReservationsBySeller - data reçue:', data);
    console.log('🔧 Service - Envoi à API:', { data });
    const response = await apiService.postForGet('reservationBilletVoyages/getReservationByUserGare', { data });
    console.log('🔧 Service - Réponse API complète:', response);
    console.log('🔧 Service - Items:', response.items);
    return response.items || [];
  }

  /**
   * Obtenir les réservations par admin transport
   * Note: L'API utilise POST au lieu de GET pour cette récupération
   */
  async getReservationsByAdminTP(data) {
    const response = await apiService.postForGet('reservationBilletVoyages/getReservationByAdminCompagnieTransport', { data });
    return response.items || [];
  }

  /**
   * Générer un billet
   */
  async generateTicket(ticketReference) {
    return await apiService.post(
      'reservationBilletVoyages/generateBilletPdf',
      { data: { designation: ticketReference } },
      { responseType: 'blob' }
    );
  }

  /**
   * Créer une réservation
   */
  async createReservation(reservationData) {
    return await apiService.post('reservationBilletVoyage', reservationData);
  }

  /**
   * Annuler une réservation
   */
  async cancelReservation(reservationId) {
    return await apiService.put(`reservationBilletVoyage/${reservationId}/annuler`);
  }

  /**
   * Obtenir les détails d'une réservation
   */
  async getReservationDetails(reservationId) {
    return await apiService.get(`reservationBilletVoyage/${reservationId}`);
  }

  /**
   * Vérifier un billet
   */
  async verifyTicket(ticketReference) {
    return await apiService.get(`billetVoyage/verifier/${ticketReference}`);
  }

  /**
   * Confirmer un billet
   */
  async confirmTicket(ticketReference) {
    return await apiService.post(`billetVoyage/confirmer/${ticketReference}`);
  }
}

export default new ReservationService();
